import { render, staticRenderFns } from "./ChangeControlHeaderComponent.vue?vue&type=template&id=65c4da56"
import script from "./ChangeControlHeaderComponent.vue?vue&type=script&lang=js"
export * from "./ChangeControlHeaderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports